import BaseExerciseMixin from '../../js/BaseExerciseMixin';
import Quiz from '../scripts/QuizClass';
import Fraction from '../scripts/Fraction';
import ScoreBox from '../ScoreBox.vue';
import ExplainSolution from '../ExplainSolution.vue';
import EndSection from '../EndSection.vue';
import FractionComponent from '../FractionComponent.vue';
import ReportButtons from '../ReportButtons';
var VueScrollTo = require('vue-scrollto');

const variables = require('../scripts/variables');
const USF = require('usefull-functions');
import Fnc from 'usefull-functions';


const $grades = variables.grades, const_fract = {num: "", den: ""};

export default {
    props:{
        skill: {type: Object, required: false},
        level: {
            type: [String, Number],
            required: false,
            default: 'any',
            validator: function (value) {
                return $grades.map(function (el) {return el.class;}).includes(value) || value == 'any' || (0 < value && value < 7);
            }
        },
        problems: { type: [Array, Object], required: true },
        saveScore: { type:Function, required:false, default: () => {} },
        titlePractice: { type:[String], required:false, default:"" },
        displayTitle: { type:[Boolean], required:false, default:true },
        isGroup: { type: [Boolean], required: false, default: false },
        numberPracticesPerActivity: { type: [Number], required: false, default: 10 },
        bestStats: {
            type: [Function, Object],
            required: false,
            default: ()=>({
                best_score_of_player: 0,
                best_player_score: 0,
                best_player_name: 'you'
            })
        },
        isDebug: { type: [Boolean], required: false, default: false },
        withReport: { type: Boolean, default: false },
        reportPractice: { type: Function, default: () => {} },
        withScore: { type: Boolean, required: false, default: true  },
        levelDebug: { type: String, required: false, default: 'practice' },
        editRoute: { type: String, default: null },
        hoverProp: { type: Function, default: () => null },
        indexQuiz: { default: 0 },
        truthsAnswers: { default: 0 },
        treatedQuizes: { default: () => [] }
    },
    name: 'BaseExercise',
    components: { ScoreBox, ExplainSolution, EndSection, ReportButtons },
    mixins: [BaseExerciseMixin],
    data(){
        return {
            quizes: this.copy_arr(this.problems),
            remainQuestions: 0,
            totalQuestion: this.problems.length,
            nbreTruthsQuestions: this.truthsAnswers,
            answeredQuestions: this.indexQuiz,
            emptyResponse: false,
            score: 0,
            submitedFraction: Object.assign({}, const_fract),
            apreciation: '',
            submitedAnswers: '',
            currentQuiz: {},
            indexQuestion: this.indexQuiz,
            oldIndex: 0,
            truthAnswer: false,
            failAnswer: false,
            showEnd: false,
            review: -1,
            treated: this.treatedQuizes || [],
            practice_themes: ['practice-theme-1','practice-theme-2','practice-theme-3'],
            groups: [],
            current_group: '',
            apreciationsTab: variables.apreciations,
            timeout: null,
            index: this.indexQuiz,
            usefull_functions: Fnc
        };
    },
    created () {
        this.initData();
    },
    mounted () {
        if (!this.isDebug && this.$refs.first_input) {
            this.$refs.first_input.focus();
        }
        this.$emit('score', this.scoreData);
        let practice_dom = {
            main: document.querySelector('.base-exercise-component'),
            head_practice: document.querySelector('#app .head-practice'),
            practice_block: document.querySelector('#app .practice-block')
        };
        practice_dom.main.classList.add(this.get_rand_array(this.practice_themes));
    },
    computed:{
        problemComponent(){
            return {
                template: Fnc.tag('div', this.currentQuiz.problem, {class: 'problem'}),
                props: ['truth', 'fail', 'solution', 'submited'],
                components: { FractionComponent },
                name: 'problem-component',
                created () {},
                methods: {},
                watch: {
                    submited (n, o) {
                    },
                    fail(n, o) {
                    }
                }
            };
        },
        solution(){
            return this.currentQuiz.answerQuiz;
        },
        type_answer(){
            return this.currentQuiz.type_answer;
        },
        endOfGame(){
            return this.answeredQuestions == this.problems.length;
            return this.quizes.filter(el => !el.passed).length == 0;
        },
        isEdit() {
            return this.levelDebug == 'edit';
        },
        hashScore() {
            return `${this.score}-${this.totalQuestion -  this.answeredQuestions}-${this.totalQuestion}-${this.answeredQuestions}-${this.nbreTruthsQuestions}`;
        },
        scoreData() {
            return {
                score: this.scoreRatio,
                passed: this.answeredQuestions,
                remain: this.totalQuestion -  this.answeredQuestions,
                succed: this.nbreTruthsQuestions,
                treated: this.treated
            };
        },
        scoreRatio() {
            if (this.answeredQuestions == 0)
                return 0;
            return parseInt((this.nbreTruthsQuestions / this.answeredQuestions).toFixed(2) * 100);
        },
        realIndex() {
            return (this.indexQuestion + this.problems.length * 10) % this.problems.length;
        },
        truthsQuestionsProps() {
            return this.truthsAnswers;
        },
        goodApreciation() {
            let tab = Fnc.copy_arr(this.apreciationsTab);
            return tab.sort_rn()[this.realIndex];
        }
    },
    methods:{
        actionButton(event){
            if(this.failAnswer || this.truthAnswer){
                this.nextQuextion(event, 1);
            }else{
                this.checkAnswer();
            }
            this.$emit('score', this.scoreData);
        },
        checkAnswer(ev){
            let submited = this.submitedAnswers;
            // log('solution:', this.solution, 'submited:', submited, 'is_fraction:', this.is_fraction(this.solution), 'this.currentQuiz.answerFraction:', this.currentQuiz.answerFraction);
            if (this.is_fraction(this.solution)) {
                let fract = this.currentQuiz.type_answer == 'radio' ? submited.val :
                    this.currentQuiz.answerFraction ? this.submitedFraction : submited;
                submited = fract || submited;
                try {
                    submited = new Fraction(fract || submited);
                } catch(e) {
                    // statements
                    // console.log(e);
                    this.emptyResponse = true;
                    this.emitEmpty();
                    this.$emit('empty-answer', this.submitedFraction);
                    return 0;
                }
            }
            if (this.currentQuiz.answerFraction) {
                if(this.submitedFraction.den.trim().length == 0 || this.submitedFraction.num.trim().length == 0){
                    this.emptyResponse = true;
                    this.emitEmpty();
                    this.$emit('empty-answer', this.submitedFraction);
                    return 0;
                }
            } else if (this.submitedAnswers.length == 0) {
                this.emptyResponse = true;
                this.$emit('empty-answer', this.submitedAnswers);
                this.emitEmpty();
                return 0;
            }
            this.answeredQuestions++;
            this.emptyResponse = false;
            this.$set(this.quizes[this.realIndex], 'passed', true);

            let good_answer = false;
            if(this.currentQuiz.answerFraction){
                good_answer = new Fraction(this.solution.simplificated).equal_to(submited,this.currentQuiz.transform_answer === 'simplificated');
            } else {
                switch (this.currentQuiz.type_answer) {
                    case 'text':
                        let solution = this.solution;
                        submited = this.submitedAnswers;
                        switch (this.currentQuiz.transform_answer) {
                            case transform_answer.nospace:
                                // log('transform_answer is nospace, solution:', solution, 'submited:', submited);
                                if (solution instanceof Array ) {
                                    solution = solution.join('||');
                                }
                                solution = solution.replace(/\s+/g, '');
                                submited = submited.replace(/\s+/g, '');
                            break;
                            default:
                            solution = this.solution;
                            break;
                        }
                        good_answer = submited == solution || solution.split('||').includes(submited);
                    break;
                    case 'int':
                        if(this.is_fraction(this.solution)){
                            good_answer = this.solution.intVal === submited.intVal;
                        }
                        good_answer = this.is_fraction(this.solution) ? this.solution.intVal == submited.intVal : parseInt(submited.toString().replace(',', '')) == this.solution;
                    break;
                    case 'float':
                        this.submitedAnswers = parseFloat(this.submitedAnswers);
                        good_answer = this.submitedAnswers == this.solution;
                    break;
                    case 'radio':
                        let submitedFraction = new Fraction(submited);
                        // log('currentQuiz.type_answer: radio', 'submited:', submited, 'this.solution:', this.solution, 'submitedFraction:', submitedFraction);
                        good_answer = this.is_fraction(submited) ? submitedFraction.equal_to(this.solution) : submited == this.solution;
                    break;
                    default:
                     good_answer = this.submitedAnswers == this.solution;
                    break;
                }
            }

            if(good_answer){
                this.nbreTruthsQuestions++;
                this.truthAnswer = true;
                this.timeout = setTimeout(() => {
                    this.nextQuextion(null, 1);
                }, 5000);
            }else{
                this.failAnswer = true;
            }

            this.treated.push({quiz: this.currentQuiz, submited: submited || this.submitedFraction, found: this.truthAnswer, index: this.realIndex + 1});
            this.score = parseInt((this.nbreTruthsQuestions / this.answeredQuestions).toFixed(2) * 100);

            let played_questions = parseInt(this.alt(this.getCookie('played-questions'), 0)) + 1;
            this.setCookie('played-questions', played_questions, 24 * 3600 * 1000);

            this.$emit('played-question');
            this.$emit('score', this.scoreData);

            if(this.endOfGame) {
                this.$emit('end', true);
                this.save_score();
            }
        },
        controlAnswer(event) {
            let value = this.submitedAnswers;
            let controlled = this.controlInput(value, this.currentQuiz.type_answer).toString();
            // log('submitedAnswers changed from:', old, 'to:', value, 'controlled:', controlled);
            if (controlled != value) {
                this.submitedAnswers = controlled;
            }
        },
        controlDenAnswer(event) {
            let value = this.submitedFraction.den,
                solution = new Fraction(this.solution),
                den = solution.den,
                type = parseInt(den) == den ? 'int' :
                    (parseFloat(den) == den ? 'float' : 'text'),
                    controlled = this.controlInput(value, type);
            // log('denominator changed to:', value, 'type:', type, 'controlled:', controlled, 'den:', den, 'solution:', solution);
            if (controlled != value) {
                this.submitedFraction.den = controlled;
            }
        },
        controlNumAnswer(event) {
            let value = this.submitedFraction.num,
                solution = new Fraction(this.solution),
                num = solution.num,
                type = parseInt(num) == num ? 'int' :
                    (parseFloat(num) == num ? 'float' : 'text'),
                    controlled = this.controlInput(value, type);
            if (controlled != value) {
                this.submitedFraction.num = controlled;
            }
        },
        controlInput(value, type) {
            switch (type) {
                case 'int':
                return value.toString().replace(/[^0-9]/gi, '');
                if( parseInt(value) != value){
                    // ev.preventDefault();
                    return value.toString().replace(/[^0-9]/gi, '');
                } else {
                    return value;
                }
                break;
                case 'float':
                    value = value.toString().replace(/[^\d.-]/g, '');
                    if (isNaN(Number(value))) {
                        return parseFloat(value).toString();
                    } else {
                        return value.toString();
                    }
                break;
                case 'litteral':
                break;
                default:
                    return value
                    break;
                }
        },
        controlInputNum(ev) {
        },
        emitEmpty() {
            this.$emit('empty-answer', this.emptyResponse);
        },
        initData(){
            let problems = this.problems;
            if(this.isGroup) {
                let group_problems = this.array_group_by(problems, 'group', 'problems');
                if(group_problems.length > 1){
                    group_problems.push({group:'All',problems:problems});
                }
                this.current_group = this.current_group == '' ?group_problems[0]['group'] : this.current_group;
                this.groups = this.copy_arr(group_problems);
                problems = group_problems.filter(el=>el.group == this.current_group).pop().problems;
            }
            this.quizes = this.copy_arr(this.copy_arr(problems.slice(0, this.numberPracticesPerActivity))).map(el => Object.assign(el, {used: 0, level: this.level, passed: false}));
            // console.log("problems:", problems, "group_problems:", this.groups, "current_group:", this.current_group, 'this.quizes:', this.quizes, 'realIndex:', this.realIndex, 'currentQuiz:', this.quizes[this.realIndex]);

            this.currentQuiz = new Quiz(this.quizes[this.realIndex], this.level);

            this.emptyResponse = false;
            this.submitedAnswers = '';
            this.showEnd = false;
            this.submitedFraction = Object.assign({}, const_fract);
            // this.solution='';

            this.initGame();
        },
        initGame(){
            this.failAnswer = false;
            this.truthAnswer = false;
            this.emptyResponse = false;
            this.submitedAnswers = '';
            if(this.currentQuiz.answerFraction){
                this.submitedFraction = Object.assign({}, const_fract);
            }
            window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
          });
            // scrollTo('#quiz-box', 200, {});
        },
        is_good_answer(prop){
            if(this.is_fraction(this.solution)){
                let solution = new Fraction(this.solution);
                return solution.equal_to(prop.val || prop);
            }else{
                return this.solution == (prop.val || prop);
            }
        },
        is_submited(prop){
            if (this.is_fraction(this.solution)) {
                let submited = new Fraction(
                    this.currentQuiz.type_answer == 'radio' ?
                        (this.submitedAnswers.val || this.submitedAnswers) :
                        this.submitedFraction
                );
                return submited.equal_to(prop.val || prop);
            }else{
                return this.submitedAnswers == (prop.val || prop);
            }
        },
        nextQuextion(event, n){
            clearTimeout(this.timeout);
            let i = this.realIndex, unSolved = this.quizes.map((el, index) => !el.passed ? index : undefined).filterInt();
            switch (n) {
                case 1:
                // i = (i + 1) % this.totalQuestion;
                i = unSolved.filter(el => el >= i)[0];
                if(i == undefined){
                    i = unSolved.getRand();
                }
                break;
                case 0:
                i = unSolved.getRand();
                break;
                case -1:
                i = this.oldIndex;

                break;
            }
            this.oldIndex = this.realIndex;
            this.indexQuestion = i;
            this.initGame();
            setTimeout(() => {
                // log('nextTick okay, problem:', this.$refs.practice);
                // this.$refs.practice.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
                if (!this.isDebug && this.$refs.first_input){
                    this.$refs.first_input.focus();
                }
            }, 0);
        },
        restartGame(){
            // this.quizes = this.quizes.sort((a,b) => 0.5 - Math.random());
            this.indexQuestion = 0;
            this.totalQuestion = this.quizes.length;
            this.nbreTruthsQuestions = 0;
            this.answeredQuestions = 0;
            this.oldIndex = 0;
            this.treated = [];
            this.initData();
            this.$emit('restart');
        },
        async save_score(rand = false){
            this.isSavingScore = true;
            try {
                let res = await this.saveScore({total_questions: this.answeredQuestions, truths_questions: this.nbreTruthsQuestions, reviews: this.treated});;
            } catch(e) {
                log_error(e);
            } finally{
                this.isSavingScore = false;
                setTimeout(() => {
                    this.showEnd = true;
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                  });
                } , 3000)
            }
        }
    },
    watch:{
        currentQuiz (quiz, old) {
            this.$emit('quiz', {...quiz, index: this.realIndex});
            // log('currentQuiz changeg from:', old, 'to:', quiz);
        },
        current_group(n,o){
            this.initData();
        },
        emptyResponse(val) {
            if (val) {
                // this.$emit('empty-answer', val);
            }
        },
        failAnswer(val) {
            if (val) {
                this.$emit('fail-answer', val);
                // log('failed answer, solving:', this.$refs.solving);
                setTimeout(() => {
                    this.$refs.solving.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
                }, 1000)
            }
        },
        hashScore(v, o) {
            this.$emit('score', this.scoreData);
        },
        realIndex(index){
            let quiz = new Quiz(this.quizes[index], this.level), obj;
            this.currentQuiz = quiz;
        },
        scoreData(old, sc) {/*
            let data_score = {
                score: parseInt(this.score),
                passed: this.answeredQuestions,
                remain: this.totalQuestion -  this.answeredQuestions,
                succed: this.nbreTruthsQuestions
            };
            // log('scoreData changed from:', old, 'to:', sc, 'data_score:', data_score);*/
            this.$emit('score', this.scoreData);
        },
        submitedAnswers(old, value) {/*
            let controlled = this.controlInput(value, this.currentQuiz.type_answer).toString();
            log('submitedAnswers changed from:', old, 'to:', value, 'controlled:', controlled);
            if (controlled != value) {
                this.submitedAnswers = controlled;
            }*/
        },
        'submitedFraction.num'(old, value) {/*
            log('submitedAnswers changed from:', old, 'to:', value, 'submitedFraction:', this.submitedFraction);
            let solution = new Fraction(this.solution), num = solution.num,
                type = parseInt(num) == num ? 'int' :
                    (parseFloat(num) == num ? 'float' : 'text'),
                    controlled = this.controlInput(value, type);
            if (controlled != value) {
                this.submitedFraction.num = controlled;
            }*/
        },
        'submitedFraction.den'(old, value) {/*
            let solution = new Fraction(this.solution), den = solution.den,
                type = parseInt(den) == den ? 'int' :
                    (parseFloat(den) == den ? 'float' : 'text'),
                    controlled = this.controlInput(value, type);
            if (controlled != value) {
                this.submitedFraction.den = controlled;
            }*/
        },
        truthAnswer(val) {
            if (val) {
                this.$emit('truth-answer', val);
            }
        }
    }
};

function scrollTo(element, duration, opt) {
    var options = Object.assign( {
        container: 'body',
        easing: 'ease-in',
        offset: -60,
        force: true,
        cancelable: true,
        onStart: function(elt) {
          // scrolling started
        },
        onDone: function(elt) {
          // scrolling is done
        },
        onCancel: function() {
          // scrolling has been interrupted
        },
        x: false,
        y: true
    }, opt);

    var cancelScroll = VueScrollTo.scrollTo(element, duration, options);
    // log('start scrolling with arguments:', arguments, 'cancelScroll:', cancelScroll);
    VueScrollTo.scrollTo(element, duration, options);/*
    cancelScroll();*/
}